import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Input, { BaseInputProps } from '../Input/Input'

type FormInputProps = { name: string; hidden?: boolean } & BaseInputProps

const FormInput: FC<FormInputProps> = (props) => {
  const formMethods = useFormContext()
  const { name, children, onChange, helperText } = props

  let hasErrors = formMethods.formState.errors[name] ? true : false
  let errorMessage = formMethods.formState.errors[name]?.message

  if (formMethods.formState.errors && name.includes('bookingReferenceValues')) {
    let referenceErrors = formMethods.formState.errors['bookingReferenceValues']

    if (referenceErrors) {
      formMethods.formState.errors['bookingReferenceValues'].forEach(
        (error) => {
          if (error.value.ref.name === name) {
            hasErrors = true
            errorMessage = error.value.message
          }
        },
      )
    }
  }

  if (formMethods.formState.errors && name.includes('.email')) {
    const nameParts = name?.split('.')
    hasErrors = formMethods.formState.errors[nameParts[0]]?.email ? true : false
    errorMessage = formMethods.formState.errors[nameParts[0]]?.email.message
  }

  return (
    <Controller
      name={name}
      control={formMethods.control}
      render={({ field }) => (
        <Input
          {...field}
          {...props}
          error={hasErrors}
          helperText={helperText || errorMessage}
          onChange={(e) => {
            field.onChange(e)
            onChange && onChange(e)
          }}
        >
          {children}
        </Input>
      )}
    />
  )
}

export default FormInput
